import { useEffect, useState } from "react"
import { StepOneModal } from "./StepOneModal"
import { StepOneOtpModal } from "./StepOneOtpModal"
import { StepThreeModal } from "./StepThreeModal"
import { StepTwoModal } from "./StepTwoModal"
import {
  AfterBanksAuthorizeResponseProps,
  AfterBanksFormProps,
  AfterBanksResponseProps,
  AfterBanksSecondResponseProps,
  ConfirmStepProps,
} from "./_interfaces"

export function AfterBanksForm({
  banksList,
  firstStepMessage,
  containerCn,
  inputSearchCn,
  ulContainerCn,
  liContainerCn,
  imageCn,
  serviceAuthorize,
  onAuthorizeError,
  onAuthorizeSuccess,
  serviceConnect,
  onConnectError,
  onConnectSuccess,
}: AfterBanksFormProps) {
  const [isFirstModalVisible, setIsFirstModalVisible] = useState(false)
  const [firstConfirmResponse, setFirstConfirmResponse] =
    useState<AfterBanksAuthorizeResponseProps>()
  const [bankListFiltered, setBankListFiltered] =
    useState<Array<AfterBanksResponseProps | undefined>>(banksList)
  const [bankSelected, setBankSelected] = useState<AfterBanksResponseProps>()
  const [selectedDocumentType, setSelectedDocumentType] = useState<
    number | null
  >(null)
  const [connectingData, setConnectingData] = useState(false)
  const [formData, setFormData] = useState<Record<string, string | number>>({})
  const [stepThreeData, setStepThreeData] =
    useState<AfterBanksSecondResponseProps>()

  const bankList = bankListFiltered ?? banksList
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e?.target?.value
    const filteredList = banksList?.filter((bank?: AfterBanksResponseProps) =>
      bank?.fullname?.toLowerCase().includes(value?.toLowerCase())
    )
    setBankListFiltered(filteredList)
  }
  const handleFirstConfirm = async (props?: ConfirmStepProps) => {
    try {
      const response = await serviceAuthorize(props)
      const firstResponse: AfterBanksAuthorizeResponseProps = response?.data
      if (firstResponse?.additionalInfo) {
        setIsFirstModalVisible(false)
      } else {
        setIsFirstModalVisible(true)
      }
      if (response?.status === 200) {
        setFirstConfirmResponse(firstResponse)
        onAuthorizeSuccess?.(firstResponse)
      } else {
        setFirstConfirmResponse(undefined)
        onAuthorizeError?.(firstResponse)
      }
      return response?.status === 200
    } catch (error) {
      Promise.reject(error)
      return false
    }
  }

  const handleSecondConfirm = async (props?: ConfirmStepProps) => {
    try {
      const response = await serviceAuthorize(props)
      const secondResponse: AfterBanksAuthorizeResponseProps = response?.data
      if (response?.status === 200) {
        setFirstConfirmResponse(secondResponse)
        onAuthorizeSuccess?.(secondResponse)
      } else {
        onAuthorizeError?.(secondResponse)
      }
      return response?.status === 200
    } catch (error) {
      Promise.reject(error)
      return false
    }
  }

  const handleThirdConfirm = async (props?: ConfirmStepProps) => {
    try {
      const response = await serviceConnect(props)
      if (response?.status === 200) {
        setFirstConfirmResponse(undefined)
        setStepThreeData(undefined)
        setFormData({})
        onConnectSuccess?.(response?.data)
      } else {
        onConnectError?.(response)
      }
      return response?.status === 200
    } catch (error) {
      Promise.reject(error)
      return false
    }
  }

  useEffect(() => {
    if (!firstConfirmResponse?.additionalInfo) {
      setFormData({})
    }
  }, [firstConfirmResponse])

  return (
    <div className={`${containerCn}`}>
      <input
        type='text'
        name='InputAfterBanksForm'
        id='InputAfterBanksForm'
        className={`tw-w-full tw-p-2 tw-mb-4 tw-border tw-border-gray-300 tw-rounded-md ${inputSearchCn}`}
        placeholder='Buscar entidad bancaria...'
        onChange={handleSearch}
      />
      {bankList?.length ? (
        <ul
          className={`tw-flex tw-grid-cols-[repeat(auto-fill,_9rem)] sm:tw-grid tw-flex-wrap tw-gap-4 sm:tw-justify-center tw-p-2 tw-overflow-hidden ${ulContainerCn}`}
        >
          {bankList?.map((bank?: AfterBanksResponseProps) => (
            <li
              className={`tw-flex tw-flex-row tw-items-center sm:tw-flex-col tw-w-full sm:tw-w-36 sm:tw-text-center tw-shrink-0 tw-gap-2 sm:tw-border tw-border-gray-100 tw-rounded-md tw-cursor-pointer sm:tw-pb-6 tw-px-2 hover:tw-bg-gray-50/40 tw-transition-colors tw-duration-150 ${liContainerCn}`}
              key={bank?.service}
              onClick={() => {
                setBankSelected(bank)
                setIsFirstModalVisible(true)
                setFormData({})
              }}
            >
              <img
                loading='lazy'
                decoding='async'
                src={bank?.imageSVG ?? bank?.image}
                alt={`${bank?.fullname} logo`}
                className={`sm:tw-w-36 tw-w-10 sm:tw-mb-2 ${imageCn}`}
              />
              {`${bank?.fullname}${
                bank?.business === "1" ? " (Empresas)" : ""
              }`}
            </li>
          ))}
        </ul>
      ) : (
        <p className='tw-text-center'>Sin resultados</p>
      )}
      <StepOneModal
        firstConfirm={[firstConfirmResponse, setFirstConfirmResponse]}
        bankSelected={bankSelected}
        connectingData={connectingData}
        setConnectingData={setConnectingData}
        form={[formData, setFormData]}
        stepOneModalState={[isFirstModalVisible, setIsFirstModalVisible]}
        onStepOneConfirm={handleFirstConfirm}
        selectedDocumentType={selectedDocumentType}
        setSelectedDocumentType={setSelectedDocumentType}
        additionalMessage={firstStepMessage}
      />

      <StepOneOtpModal
        firstConfirm={[firstConfirmResponse, setFirstConfirmResponse]}
        bankSelected={bankSelected}
        connectingData={connectingData}
        form={[formData, setFormData]}
        setConnectingData={setConnectingData}
        stepOneModalState={[isFirstModalVisible, setIsFirstModalVisible]}
        onStepOneConfirm={handleFirstConfirm}
        selectedDocumentType={selectedDocumentType}
        setSelectedDocumentType={setSelectedDocumentType}
        additionalMessage={firstStepMessage}
      />
      <StepTwoModal
        form={[formData, setFormData]}
        firstConfirm={[firstConfirmResponse, setFirstConfirmResponse]}
        bankSelected={bankSelected}
        onStepTwoConfirm={handleSecondConfirm}
        connectingData={connectingData}
        setConnectingData={setConnectingData}
      />
      {firstConfirmResponse?.additionalInfo?.products && (
        <StepThreeModal
          form={[formData, setFormData]}
          firstConfirm={[firstConfirmResponse, setFirstConfirmResponse]}
          bankSelected={bankSelected}
          onStepThreeConfirm={handleThirdConfirm}
          stepThreeData={stepThreeData}
          setStepThreeData={setStepThreeData}
          connectingData={connectingData}
          setConnectingData={setConnectingData}
        />
      )}
    </div>
  )
}
